import client from '@/lib/axios-client'
import type {
	DDSMonthlyThemeInput,
	DDSMonthlyThemeListOutput,
	DDSMonthlyThemeListParams,
	DDSMonthlyThemeOutput,
	UpdateDDSMonthlyThemeBody,
} from '@/types/dds-monthly-theme'

const DDS_MONTHLY_THEMES_URL = '/dds-monthly-themes'

// ── GET /dds-monthly-themes ───────────────────────────────────────────────────

export async function getDDSMonthlyThemes(
	params?: DDSMonthlyThemeListParams,
): Promise<DDSMonthlyThemeListOutput> {
	const response = await client.get(DDS_MONTHLY_THEMES_URL, { params })
	return response.data.data
}

// ── POST /dds-monthly-themes ──────────────────────────────────────────────────

export async function createDDSMonthlyTheme(
	body: DDSMonthlyThemeInput,
): Promise<DDSMonthlyThemeOutput> {
	const response = await client.post(DDS_MONTHLY_THEMES_URL, body)
	return response.data.data
}

// ── PUT /dds-monthly-themes/:id ───────────────────────────────────────────────

export async function updateDDSMonthlyTheme(
	id: string,
	body: UpdateDDSMonthlyThemeBody,
): Promise<DDSMonthlyThemeOutput> {
	const response = await client.put(`${DDS_MONTHLY_THEMES_URL}/${id}`, body)
	return response.data.data
}
